import classnames from 'classnames';

import { Check } from '@/core/tamagoshi/icons/Check';
import { Text } from '@/core/tamagoshi/Text/Text';

import styles from './TableCell.module.scss';

interface TableCellProps {
  tag: 'td' | 'th';
  children: React.ReactNode;
  highlight?: boolean;
  checked?: boolean;
}

export const TableCell: React.FC<TableCellProps> = ({
  tag,
  children,
  highlight = false,
  checked,
}) => (
  <Text
    className={classnames({
      [styles.root]: checked,
    })}
    tag={tag}
    weight={highlight ? 'semiBold' : 'regular'}
    type="small"
  >
    {checked && <Check />}
    <span>{children}</span>
  </Text>
);
